import { render, staticRenderFns } from "./parameterListEdit.vue?vue&type=template&id=2cf22bc7&scoped=true&"
import script from "./parameterListEdit.vue?vue&type=script&lang=js&"
export * from "./parameterListEdit.vue?vue&type=script&lang=js&"
import style0 from "./parameterListEdit.vue?vue&type=style&index=0&id=2cf22bc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf22bc7",
  null
  
)

export default component.exports